module.exports = __webpack_public_path__ + "img/eco5.945c9265.png";